import React from 'react';
import { Calendar, MessageSquare, ListTodo, BrainCircuit } from 'lucide-react';
export function DiagnosticoSection() {
  return <section className="bg-[#FFFFFF] py-24 md:py-32 px-6 md:px-12 lg:px-24" data-id="element-27">
      <div className="max-w-5xl mx-auto flex flex-col items-center text-center space-y-16" data-id="element-28">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-[#0F0F0F]" data-id="element-29">
          Si tu día se ve así…
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 w-full" data-id="element-30">
          <div className="flex flex-col items-center space-y-4 p-6 border border-[#0F0F0F]/10 rounded-2xl" data-id="element-31">
            <Calendar className="w-12 h-12 text-[#C9A96E]" data-id="element-32" />
            <p className="text-xl font-semibold text-[#0F0F0F]" data-id="element-33">Agenda llena</p>
          </div>
          <div className="flex flex-col items-center space-y-4 p-6 border border-[#0F0F0F]/10 rounded-2xl" data-id="element-34">
            <MessageSquare className="w-12 h-12 text-[#C9A96E]" data-id="element-35" />
            <p className="text-xl font-semibold text-[#0F0F0F]" data-id="element-36">
              Mensajes todo el día
            </p>
          </div>
          <div className="flex flex-col items-center space-y-4 p-6 border border-[#0F0F0F]/10 rounded-2xl" data-id="element-37">
            <ListTodo className="w-12 h-12 text-[#C9A96E]" data-id="element-38" />
            <p className="text-xl font-semibold text-[#0F0F0F]" data-id="element-39">
              Tareas acumuladas
            </p>
          </div>
          <div className="flex flex-col items-center space-y-4 p-6 border border-[#0F0F0F]/10 rounded-2xl" data-id="element-40">
            <BrainCircuit className="w-12 h-12 text-[#C9A96E]" data-id="element-41" />
            <p className="text-xl font-semibold text-[#0F0F0F]" data-id="element-42">
              Decisiones tomadas cansado
            </p>
          </div>
        </div>

        <div className="space-y-2 max-w-2xl mx-auto" data-id="element-43">
          <p className="text-xl md:text-2xl text-[#0F0F0F]" data-id="element-44">
            pero tu negocio no crece al nivel que podría…
          </p>
          <p className="text-xl md:text-2xl text-[#0F0F0F]" data-id="element-45">
            tu problema no es vender.
          </p>
          <p className="text-2xl md:text-3xl font-bold text-[#0F0F0F]" data-id="element-46">
            Es estructura.
          </p>
        </div>
      </div>
    </section>;
}